class Cart {
    constructor(cartContainer, options = {}){
        this.options = Object.assign(
            {},
            {   
                minicart: true
            }, 
            options
        );    
 

        //Variables
        this.lineCount = 0; 
        this.cartContainer = cartContainer;   
        this.cartOpen = false;
        this.contentItems = this.cartContainer.querySelector(".content-list-items"); 
        this.contentTotal = this.cartContainer.querySelector(".content-total");
        this.btnCo = this.cartContainer.querySelector("#btn-checkout"); 
        this.btnCart = document.querySelector("#btn-cart");
        this.cartDatas = JSON.parse(document.querySelector('#cart-json').textContent);  


        this.cartCount = document.querySelector("#cart-count");
        this.header = document.querySelector("#header");
        this.body = document.querySelector("body");
 

        this.cartContainer.querySelectorAll(".close-cart, .close").forEach(cc => {
            cc.addEventListener("click", () => {
                this.closeCart();
            });
        });
         

        var addToCart = document.querySelectorAll(".add-to-cart");
        addToCart.forEach(btnAdd => {
          btnAdd.addEventListener("click", () => {
            let props = "";
            if(typeof btnAdd.getAttribute("data-props") != "undefined"){
                props = JSON.parse(btnAdd.getAttribute("data-props"));
            }
            var vid = btnAdd.getAttribute("data-vid");
            this.addLoading(btnAdd);
            this.addItem(vid, 1, props, btnAdd); 
          });
        });  

        //INIT
        this.buildCart(this.cartDatas);  

        document.querySelectorAll(".reorder").forEach(btn => {
            btn.addEventListener("click", () => { 
                let ids = btn.getAttribute("data-ids").split(",");
                this.addItemArray(ids, "", btn);
            });
        });
 
        document.addEventListener("click", (event) => {  
            if(this.cartOpen){
                if(event.target.closest("#cart") == null){ 
                    this.closeCart();
                } 
            }
        }); 
 
    }  
 

    async majCountCart(number){
        if(this.cartCount != null){
            this.cartCount.innerHTML = number;
        }
    }

    async majPriceCart(cart){  
        var oldprice = 0; 
        let itemsCount = 0
        cart.items.forEach(item => {  
            if(typeof catalog[item.variant_id] != "undefined"){
                if(parseInt(catalog[item.variant_id].data_compare_at_price) > parseInt(catalog[item.variant_id].data_price)){
                    oldprice += parseInt(catalog[item.variant_id].data_compare_at_price) * item.quantity;
                }else{
                    oldprice += parseInt(catalog[item.variant_id].data_price) * item.quantity;
                } 
                itemsCount += item.quantity;
            }
        }); 
        /*
        if(oldprice > cart.total_price){
            this.cartContainer.querySelector(".content-totals .oldtotal").innerHTML = this.formatPrice(oldprice);
        }else{
            this.cartContainer.querySelector(".content-totals .oldtotal").innerHTML = "";
        }
        */
        this.cartContainer.querySelector(".content-totals .items .count-items").innerHTML = itemsCount;
        this.cartContainer.querySelector(".content-totals .total").innerHTML = this.formatPrice(cart.total_price);
    }

    addLoading(element){
      element.classList.add("loading");
    }

    removeLoading(element){ 
      element.classList.remove("loading");
    }

    formatPriceOffer(price, currency){
        switch(currency){
            case "EUR" : var devise = "€"; break;
            default : var devise = "€";  
        }
        return (price).toFixed(2)+ devise;
    }

    formatPrice(price, currency){
        switch(currency){
            case "EUR" : var devise = "€"; break;
            default : var devise = "€";  
        }
        return (parseInt(price) / 100).toFixed(2) + devise;
    }

    updateItemFront(cart, item, line, callback, majCart){  
        var itemTarget = this.contentItems.querySelector(".content-item[data-line='"+ line +"']");
        if(itemTarget.querySelector(".content-current") != null){
        itemTarget.querySelector(".content-current").innerHTML = item.quantity;
        }
        if(item.line_price == 0){
            itemTarget.querySelector(".content-price .price").innerHTML = "Offert";
        }else{
            itemTarget.querySelector(".content-price .price").innerHTML = this.formatPrice(item.line_price);
        } 
        itemTarget.setAttribute("data-qty", item.quantity); 
        itemTarget.setAttribute("data-price", item.final_line_price); 
        if(callback != "" && typeof callback == "function"){
            callback();
        } 
        if(majCart){
            this.majCart(cart);
        } 
    }

    removeItemFront(cart, item, line, callback, majCart){
        var itemTarget = this.contentItems.querySelector(".content-item[data-line='"+ line +"']");
        setTimeout(()=>{
            itemTarget.remove(); 
            if(majCart){
                this.majCart(cart);
            }
        }, 600);
        if(callback != "" && typeof callback == "function"){
            callback();
        }
        itemTarget.classList.add("remove");
    }

    async resetLine(cart){
        cart.items.forEach((item, line)  => {
            let vid = item.variant_id;
            this.contentItems.querySelector(`.content-item[data-vid="${vid}"]`).setAttribute("data-line", line);
        }); 
    } 
 

    buildItem(item, line){      
        var contentItem = this.createElementWithClass("div", "content-item");  
        contentItem.setAttribute("data-line", line);
        contentItem.setAttribute("data-qty", item.quantity);
        contentItem.setAttribute("data-id", item.id);
        contentItem.setAttribute("data-vid", item.variant_id);
        contentItem.setAttribute("data-sku", item.sku);
        contentItem.setAttribute("data-price", item.final_line_price); 
        contentItem.setAttribute("data-type", item.product_type); 
        var contentItemLeft = this.createElementWithClass("div", "content-item-left");  
        var contentItemRight = this.createElementWithClass("div", "content-item-right"); 
        var contentItemRightTop = this.createElementWithClass("div", "content-item-right-top");
        var contentItemRightBottom = this.createElementWithClass("div", "content-item-right-bottom"); 

        //Content Left
        var contentImage = this.createElementWithClass("div", "content-image");  
        if(typeof item.featured_image != "undefined" && item.featured_image.url != ""){ 
            var urlImgSplit = item.featured_image.url.split("."); 
            if(item.featured_image.url.indexOf(".com") != -1){ 
                var urlImg = urlImgSplit[0] + "." + urlImgSplit[1] + "." + urlImgSplit[2] + "_80x." + urlImgSplit[3];
            }else{
                var urlImg = urlImgSplit[0] + "." + urlImgSplit[1] + "_80x." + urlImgSplit[2];
            } 
            contentImage.innerHTML = `<img src="${urlImg}" alt="${item.title}" />`; 
        } 
   
        //Content Mid
        var contentTitlePrd = this.createElementWithClass("div", "content-title");  
        contentTitlePrd.innerHTML = item.product_title;  

        //Qty
        var contentQty = this.createElementWithClass("div", "content-qty");
        var contentQtyMinus = this.createElementWithClass("div", "content-min"); 
        var contentQtyCurrent = this.createElementWithClass("div", "content-current"); 
        var contentOption = this.createElementWithClass("div", "content-option"); 
        if(typeof item.options_with_values != "undefined"){
            contentOption.innerHTML = item.options_with_values[0].name + ": " + item.options_with_values[0].value;
        }
        contentQtyCurrent.innerHTML = "Qty " + item.quantity;
        var contentQtyPlus = this.createElementWithClass("div", "content-plus"); 
        if(item.price != 0){
            //contentQty.appendChild(contentQtyMinus); 
            contentQty.appendChild(contentQtyCurrent); 
            //contentQty.appendChild(contentQtyPlus); 
        }  

        //Content Right
        var btnRemove = this.createElementWithClass("div", "btn-remove");
        btnRemove.innerHTML = `Remove`; 


        var contentPrice = this.createElementWithClass("div", "content-price");  
        var oldprice = this.createElementWithClass("div", "oldprice"); 
        var price = this.createElementWithClass("div", "price"); 
        price.innerHTML = this.formatPrice(item.discounted_price, cart.currency);  
        if(typeof catalog[item.variant_id] != "undefined" && typeof catalog[item.variant_id].data_compare_at_price != "undefined" && parseInt(catalog[item.variant_id].data_compare_at_price) > parseInt(catalog[item.variant_id].data_price)){ 
            oldprice.innerHTML = this.formatPrice(catalog[item.variant_id].data_compare_at_price);
        }else{
            if(typeof catalog[item.variant_id] != "undefined" && typeof catalog[item.variant_id].data_price != "undefined" && parseInt(catalog[item.variant_id].data_price) > parseInt(item.discounted_price)){
                oldprice.innerHTML = this.formatPrice(catalog[item.variant_id].data_price);
            }else{
                oldprice.innerHTML = "";
            } 
        }
        
        contentPrice.appendChild(oldprice);
        contentPrice.appendChild(price); 

        //buildLoader
        var contentLoader = this.createElementWithClass("div", "content-loader");
        var loader = this.createElementWithClass("div", "loader");
        var midLoader = this.createElementWithClass("div", "mid");
        loader.appendChild(midLoader);
        contentLoader.appendChild(loader); 
        contentPrice.appendChild(contentLoader);

        //Last build
        contentItemLeft.appendChild(contentImage);

        contentItemRightTop.appendChild(contentTitlePrd);  
        contentItemRightTop.appendChild(btnRemove);

        contentItemRightBottom.appendChild(contentOption);
        contentItemRightBottom.appendChild(contentQty);  
        contentItemRightBottom.appendChild(contentPrice); 
        

        contentItemRight.appendChild(contentItemRightTop);
        contentItemRight.appendChild(contentItemRightBottom);

        contentItem.appendChild(contentItemLeft);  
        contentItem.appendChild(contentItemRight); 

        //Event +/-/delete
        /*
        contentQtyPlus.addEventListener("click", () => {
            contentItem.classList.toggle("loading"); 
            var newQty = parseInt(contentItem.getAttribute("data-qty")) + 1;
            var line = parseInt(contentItem.getAttribute("data-line"));
            var callback = function(){
                contentItem.classList.toggle("loading"); 
            };
            this.updateItem(item.variant_id, newQty, line, callback, contentItem.getAttribute("data-type"));
        });
        */

        /*
        contentQtyMinus.addEventListener("click", () => {
            contentItem.classList.toggle("loading");
            var newQty = parseInt(contentItem.getAttribute("data-qty")) - 1;
            var line = parseInt(contentItem.getAttribute("data-line"));
            var callback = () => {
                contentItem.classList.toggle("loading");
            };
            this.updateItem(item.variant_id, newQty, line, callback, contentItem.getAttribute("data-type")); 
        }); 
        */

        btnRemove.addEventListener("click", () => {
            contentItem.classList.toggle("loading");  
            var line = parseInt(contentItem.getAttribute("data-line"));
            let qty = parseInt(contentItem.getAttribute("data-qty"));
            var callback = function(){
                contentItem.classList.toggle("loading"); 
            };
            this.updateItem(item.variant_id, 0, line, callback, contentItem.getAttribute("data-type"));
        });   

        return contentItem;
    } 

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    } 

    async buildCart(cart){   
        let cartCheck = await this.getCart(); 
        if(cart.total_price != cartCheck.total_price){
            cart = cartCheck;
        } 
        cart.items.forEach(item => {    
            this.contentItems.appendChild(this.buildItem(item, this.lineCount));
            this.lineCount += 1; 
        });
        this.majCountCart(cart.item_count);
        this.majPriceCart(cart);   
    } 

    createElementWithClass(type, className){
        var element = document.createElement(type);
        element.classList.add(className);
        return element;
    }

    closeCart(){
        this.header.classList.toggle('cart-open'); 
        this.cartContainer.classList.toggle("open");
        this.body.classList.toggle('freeze');
        document.querySelector("html").classList.toggle('freeze');  
        setTimeout(() => {
            this.cartOpen = !this.cartOpen;
        }, 200);
    }

    openCart(){
        this.header.classList.toggle('cart-open'); 
        this.cartContainer.classList.toggle("open");
        this.body.classList.toggle('freeze');
        document.querySelector("html").classList.toggle('freeze');  
        setTimeout(() => {
            this.cartOpen = !this.cartOpen;
        }, 200);
    }

    async majCart(cart){   
        await this.resetLine(cart);  
        await this.majCountCart(cart.item_count);
        await this.majPriceCart(cart);
        await this.majPriceItem(cart);    
        this.removeLoading(this.btnCo);
    }

    async majPriceItem(cart){
        cart.items.forEach(item => {   
            if(document.querySelector(".content-list-items .content-item[data-vid='" + item.variant_id + "']") != null){
                if(item.final_line_price != 0){
                    document.querySelector(".content-list-items .content-item[data-vid='" + item.variant_id + "'] .price").innerHTML = this.formatPrice(item.discounted_price);
                }
                if(typeof catalog[item.variant_id] != "undefined" && typeof catalog[item.variant_id].data_compare_at_price != "undefined" && parseInt(catalog[item.variant_id].data_compare_at_price) > parseInt(catalog[item.variant_id].data_price)){ 
                    document.querySelector(".content-list-items .content-item[data-vid='" + item.variant_id + "'] .oldprice").innerHTML = this.formatPrice(catalog[item.variant_id].data_compare_at_price);
                }else{
                    if(typeof catalog[item.variant_id] != "undefined" && typeof catalog[item.variant_id].data_price != "undefined" && parseInt(catalog[item.variant_id].data_price) > parseInt(item.discounted_price)){
                        document.querySelector(".content-list-items .content-item[data-vid='" + item.variant_id + "'] .oldprice").innerHTML = this.formatPrice(catalog[item.variant_id].data_price);
                    }else{
                        document.querySelector(".content-list-items .content-item[data-vid='" + item.variant_id + "'] .oldprice").innerHTML = "";
                    } 
                }
            }
        });
    }

    async getCart() {
        const result = await fetch("/cart.js", {method :"GET", credentials: 'same-origin'}); 
        const res = await result.json();   
        if(res.items.length > 0){
            if(this.cartContainer.classList.contains("empty")){
                this.cartContainer.classList.remove("empty"); 
            }
            if(this.btnCart != null && !this.btnCart.classList.contains("on")){
                this.btnCart.classList.add("on"); 
            } 
        }else{
            this.cartContainer.classList.add("empty");
            if(this.btnCart != null && this.btnCart.classList.contains("on")){
                this.btnCart.classList.remove("on"); 
            } 
        }
        return res;
    }

    async clearCart() {
        const result = await fetch("/cart/clear.js", {method :"POST", credentials: 'same-origin'}); 
        const res = await result.json();  
        if(res.items.length > 0){
            //minicart.classList.remove("empty");
        }else{
            //minicart.classList.add("empty"); 
        }
        return res;
    } 

    async checkCartId(id){  
        const cart = await this.getCart();   
        var obj = false;
        if(cart.items.length > 0){  
          cart.items.forEach(function(item, index){ 
            if(item.id == id){
              obj = {id:id, line:index, qty:item.quantity}; 
              if(item.properties != null && Object.keys(item.properties).length != 0){
                obj["properties"] = item.properties;
              }
              return obj;  
            }
          });
        }
        return obj;
    } 

    async addItem(vid, qty, props, btn, open, callback) {  
        //this.btnCo.classList.add("loading");
        let config = {
          "id": vid, 
          "form_type": "product",
          "quantity": qty
        };  
        if(props != ""){
          config["properties"] = props; 
        }     

        const checkCart = await this.checkCartId(vid);   
        if(checkCart == false){ 
            const result = await fetch("/cart/add.js", {
                method: "POST",
                credentials: 'same-origin',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(config)
            });
            const res = await result.json();   
            this.lineCount += 1;
            this.contentItems.prepend(this.buildItem(res, this.lineCount)); 
            const cart = await this.getCart();   
            this.majCart(cart);
        }else if(typeof checkCart == "object"){    
            var qtyUp = checkCart.qty + 1;
            this.updateItem(checkCart.id, qtyUp, checkCart.line); 
        } 
        if(open != false){
            this.openCart();
        }
        if(typeof btn != "undefined" && btn != ""){
            this.removeLoading(btn);
        }
        if(callback != "" && typeof callback == "function"){
            callback();
        }
        if(typeof btn != "undefined" && btn != "" && btn.classList.contains("sample")){
            this.removeLoading(btn);
        } 
    }  

    async updateItem(vid, quantity, line, callback, product_type, majCart = true) {  
        this.btnCo.classList.add("loading");
        const result = await fetch("/cart/change.js", {
            method: "POST", 
            credentials: 'same-origin',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            //accept only string
            body: JSON.stringify({
              id : vid.toString(),
              quantity : quantity.toString()
            })
        });
        const res = await result.json(); 
        const cart = await this.getCart();     
        var itemUpdated = res.items[line];
        var itemsCount = cart.item_count;   
        if(quantity != 0){  
            if(callback != "" && typeof callback == "function"){
                this.updateItemFront(cart, itemUpdated, line, callback, majCart); 
            }else{
                this.updateItemFront(cart, itemUpdated, line, "", majCart); 
            }
        }else{  
            if(callback != "" && typeof callback == "function"){
                this.removeItemFront(cart, itemUpdated, line, callback, majCart); 
            }else{
                this.removeItemFront(cart, itemUpdated, line, "", majCart); 
            }   
            this.lineCount -= 1; 
        } 
    } 
} 